<div
    class="data-table-grid"
    [class.borderless]="borderless"
    #scrollRegion
    data-cy="tableBody"
>
    <ag-grid-angular
        [theme]="theme"
        [rowData]="rows"
        [columnDefs]="columnDefs"
        [defaultColDef]="defaultColDef"
        [context]="this"
        [rowSelection]="rowSelection"
        [selectionColumnDef]="selectionColumnDef"
        [getRowId]="getRowId"
        [rowClassRules]="rowClassRules"
        [headerHeight]="headerHeight"
        [floatingFiltersHeight]="floatingFiltersHeight"
        [getRowHeight]="getRowHeight"
        [sortingOrder]="sortingOrder"
        [suppressDragLeaveHidesColumns]="true"
        [suppressFieldDotNotation]="true"
        [suppressCellFocus]="true"
        [enableCellTextSelection]="true"
        [ensureDomOrder]="true"
        [domLayout]="autoHeight ? 'autoHeight' : 'normal'"
        overlayNoRowsTemplate="<span>No data to display</span>"
        (gridReady)="onGridReady($event)"
        (sortChanged)="onSortChanged($event)"
        (dragStopped)="onDragStopped($event)"
        (selectionChanged)="onSelectionChanged($event)"
    ></ag-grid-angular>
</div>

<div class="table-footer">
    <div class="footer-section count-buttons">
        <ng-select
            *ngIf="fixedPageSize"
            class="pagination-dropdown dropup"
            [items]="tableConfig.limitSelection"
            [ngModel]="itemLimit"
            (change)="setItemLimit($event)"
            [appendTo]="'body'"
            [clearable]="false"
            [searchable]="false"
            placeholder="Items per page"
        ></ng-select>
        <ng-container *ngIf="selected.length > 0">
            <button
                *ngFor="let action of tableConfig.bulkActions"
                type="button"
                class="btn btn-default btn-sm left-buffer"
                placement="top"
                [tooltip]="action.tooltip"
                [disabled]="working"
                (click)="doBulkAction(action)"
            >
                {{ action.name }}
            </button>
        </ng-container>
    </div>
    <div class="footer-section pagination-table">
        <pagination
            *ngIf="showPagination"
            class="pagination-sm"
            [totalItems]="footerTotalItems"
            [itemsPerPage]="pageLimit"
            [maxSize]="5"
            [boundaryLinks]="true"
            [ngModel]="footerCurrentPage + 1"
            (pageChanged)="onFooterPageChanged($event.page)"
        ></pagination>
    </div>
    <div
        class="footer-section scanability-buttons"
        [class.hidden]="scanability !== 'SELECTABLE'"
    >
        <button
            class="comfortable"
            type="button"
            [disabled]="activeScan === 'alternate'"
            [class.active]="activeScan === 'alternate'"
            (click)="setScanType('alternate')"
        >
            <span class="fa fa-list"></span>
        </button>
        <button
            class="alternating"
            type="button"
            [disabled]="activeScan === 'comfortable'"
            [class.active]="activeScan === 'comfortable'"
            (click)="setScanType('comfortable')"
        >
            <span class="fa fa-line-height"></span>
        </button>
    </div>
</div>
